import { InjectionToken } from '@angular/core';

export interface IFormConfig {
  markRequiredFields: boolean;
}

export const FORM_CONFIG = new InjectionToken<IFormConfig>('form_config');
